import { prefixes, prependIntlIds } from "../utils";

export const unprefixedToastMessages = {
  preventedSubmit:
    "Cannot save model when critical validation errors are present (bold)",

  "alertText.missing_detail": "You need to set detail when editing is allowed",

  "alertText.duplicateSelectValues":
    "Some of presentation template items have duplicate select values",

  "alertText.duplicateSelectNames":
    "Some of presentation template items have duplicate select values",

  "alertText.missingHegClassId": "Select a HeG class",

  "alertText.missingHegFolderId": "Select a HeG folder",

  "alertText.missingItemColumnAlias": "Select an item link column",

  "alertText.overviewHasNoMobileLayout":
    "Template is missing mobile cell layout. This means it cannot be displayed on mobile devices",

  "alertText.detailHasNoMobileLayout":
    "Detail templates require a mobile row layout to work",

  "alertText.emptySortOrder":
    "One of the items with sort type is missing sort order",

  "alertText.missingHegFileRelation":
    "One of the Heg File items is missing a linking template",

  "alertText.missingColumn": "One of the items is missing join column",

  "alertText.missingDisplayColumn":
    "One of the items is missing display column",

  "alertText.importantKpiThresholdExceedsCritical":
    "Important KPI threshold cannot exceed critical threshold",

  "alertText.itemLinkColumnNotRepresentedInDataModel":
    "One of item link columns is not present as a column in data model. It is necessary to add it there (possibly as hidden)",

  "alertText.missingOverviewTemplate":
    "User notifications will not be generated until you connect the overview template",

  "alertText.missingTitleAtribute": "No title is set on any of the attributes.",
};

export default prependIntlIds(
  prefixes.tBuilderValidation,
  unprefixedToastMessages
);
